// Aviso embaixo do campo do cadastro: o que o sistema entendeu do código.
// A limpeza e o dígito do EAN moram em lib/codigoBarras.js (o Balcão usa os
// mesmos) — o servidor limpa igual (backend/api/v1/products/codigo_barras.py).
import { digitoGtinConfere, limparCodigo } from "../../lib/codigoBarras";

export { limparCodigo };

const NOMES_GTIN = { 8: "EAN-8", 12: "UPC", 13: "EAN-13", 14: "GTIN-14" };

// Devolve { texto, tom } pra linha de ajuda abaixo do campo, ou null.
export function avisoDoCodigo(bruto) {
  const codigo = limparCodigo(bruto);
  if (!codigo) return null;
  if (!/^[0-9A-Z]+$/.test(codigo)) {
    return { texto: "Use só números e letras", tom: "erro" };
  }
  // Até 6 dígitos: é também o número do produto na balança — o Balcão acha o
  // produto pela etiqueta que a balança imprime (2 + esse número + valor).
  if (/^\d{1,6}$/.test(codigo)) {
    return { texto: "Código interno — também vale como código do produto na balança", tom: "neutro" };
  }
  const nome = /^\d+$/.test(codigo) ? NOMES_GTIN[codigo.length] : null;
  if (!nome) return { texto: "Código interno", tom: "neutro" };
  if (!digitoGtinConfere(codigo)) {
    return { texto: `${nome} com o último dígito errado — confira os números`, tom: "alerta" };
  }
  // Etiqueta de balança: começa com 2 e traz o preço dentro do código, então
  // muda a cada pesagem — o que vai no cadastro é só o número do produto.
  if (codigo.length === 13 && codigo.startsWith("2")) {
    return { texto: `Começa com 2: se for etiqueta de balança, cadastre só o número do produto (${codigo.slice(1, 6)})`, tom: "alerta" };
  }
  return { texto: `${nome} válido`, tom: "ok" };
}
